export default __webpack_public_path__ + "i18n/translations/translation-ta.ba739ef0.json";